<template>
    <div class="skeleton-loader">
        <div class="skeleton-loader__wrapper">
            <div class="skeleton-loader__item skeleton-animation"></div>
            <div class="skeleton-loader__item skeleton-animation"></div>
            <div class="skeleton-loader__item skeleton-animation"></div>
            <div class="skeleton-loader__item skeleton-animation"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonLoader',
}
</script>
